module.exports = __webpack_public_path__ + "static/media/distance_flash.d3f05338.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/image/scene/distance_flash.mp4
// module id = 771
// module chunks = 0